import React from "react";

const MobilePending = () => {
  return (
    <>
      <div className="outer-box-subscription" style={{zIndex:"10000"}}>
        <div className="inner-box-subscription" style={{width:"90%", height:"90%", display: "flex", flexDirection: "column",
        justifyContent: "center", alignItems: "center"}}>
          <div className="container-subscription-message" style={{fontSize:"1.5rem", height:"10%"}}>Mobilversion under utveckling</div>
          <div className="container-subscription-message" style={{height:"10%", padding:"5%"}}>För tillfället är ni välkomna att ta del av theBiZ i vår desktop version.</div>
        </div>
      </div>
    </>
  );
};
export default MobilePending;
